export const briefs = {
  brief: {
    briefSectionViewer: {
      typeYourContentHere: 'Type your content here...',
    },
    constants: {
      approval: 'Approval',
      assetProduction: 'Asset Production',
      campaign: 'Campaign',
      content: 'Content',
      creative: 'Creative',
      design: 'Design',
      intake: 'Intake',
      marketing: 'Marketing',
      media: 'Media',
      rebrief: 'Rebrief',
    },
  },
  briefGeneration: {
    briefGenerationProgressModal: {
      cancelGeneration: 'Cancel generation?',
      cancelGeneration2: 'Cancel generation',
      generatingBrief: 'Generating brief...',
      generationIsInProgressIf:
        'Generation is in progress. If you cancel now, your brief will not be saved.',
      keepGenerating: 'Keep generating',
      newBrief: 'New brief',
      retry: 'Retry',
    },
    briefGenerationStream: {
      malformedWidgetEvent: 'Malformed brief generation widget event',
      malformedBriefOutput: 'The generated brief could not be read',
    },
    briefGenerationThumbnail: {
      brief: 'Brief',
    },
    briefIntakeChip: {
      remove: 'Remove {{label}}',
    },
    briefIntakeComposer: {
      addContext: 'Add context',
      attachArtifacts: 'Attach artifacts',
      describeWhatYouWantTo:
        'Describe what you want to achieve, share what you know and attach everything you have...',
      goals: 'Goals',
      uploadDocuments: 'Upload documents',
    },
    briefIntakeFileList: {
      removeFile: 'Remove {{fileName}}',
    },
    briefIntakeModal: {
      addContext: 'Add context',
      addSelected: 'Add ({{selectedCount}})',
      attachFiles: 'Attach files',
      back: 'Back',
      briefTemplate: 'Brief template',
      enterBriefTitle: 'Enter brief title',
      generate: 'Generate',
      couldNotLoadTemplates: 'Could not load brief templates.',
      createAndPublishOne: 'Create and publish one',
      loadingTemplates: 'Loading brief templates',
      manageTemplates: 'Manage templates',
      noTemplatesPublished:
        'No published brief templates yet. Only published templates are listed.',
      onlyPublishedTemplatesListed: 'Only published templates are listed.',
      selectAWorkspaceToContinue: 'Select a workspace to continue.',
      selectTemplate: 'Select template',
      title: 'Title',
      tryAgain: 'Try again.',
    },
    buildDisplaySteps: {
      analyzeYourInstructions: 'Analyze your instructions',
      checkSelectedKnowledgeBase: 'Check selected knowledge base',
      generateYourBrief: 'Generate your brief',
      lookAtProjectContext: 'Look at project context',
      readUploadedFiles: 'Read uploaded files',
      reviewSelectedArtifacts: 'Review selected artifacts',
    },
    knowledgeBasePicker: {
      clear: 'Clear',
      clearSelectedKnowledgeBases: 'Clear selected knowledge bases',
      knowledgeBases: 'Knowledge Bases ({{baseCount}})',
      knowledgeBases2: 'Knowledge bases',
      knowledgeBasesSelected: 'Knowledge bases, {{selectedCount}} selected',
      noKnowledgeBasesFound: 'No knowledge bases found',
      search: 'Search...',
      searchLabel: 'Search knowledge bases',
    },
    useBriefGeneration: {
      briefGenerationStreamFailed: 'Brief generation stream failed',
      failedToStartBriefGeneration: 'Failed to start brief generation',
      failedToUploadFilesPlease: 'Failed to upload files. Please try again.',
    },
  },
  briefTemplateCreation: {
    briefTemplateIntakeModal: {
      add: 'Add',
      addContext: 'Add context',
      addExistingArtifacts: 'Add existing artifacts',
      addSelected: 'Add ({{selectedCount}})',
      attachFiles: 'Attach files',
      back: 'Back',
      browseMonksFlowArtifacts: 'Browse Monks.Flow artifacts',
      cancel: 'Cancel',
      createTemplate: 'Create template',
      describeWhatYouWantTo:
        'Describe what you want to achieve, share what you know and attach everything you have...',
      enterTemplateTitle: 'Enter template title',
      generate: 'Generate',
      generateWithAi: 'Generate with AI',
      generatingBriefTemplate: 'Generating brief template...',
      howToStart: 'How to start',
      newBriefTemplate: 'New brief template',
      removeArtifact: 'Remove {{name}}',
      removeFile: 'Remove {{fileName}}',
      selectAWorkspaceToContinue: 'Select a workspace to continue.',
      startBlank: 'Start blank',
      startBlankHint: "You'll start with no sections and add them yourself.",
      title: 'Title',
      uploadContextToEnrichYour: 'Upload context to enrich your template',
      uploadFile: 'Upload file',
      waitAMomentUntilWe: 'Wait a moment until we finish preparing your template',
    },
    templateGenerationStream: {
      malformedTemplateOutput: 'The generated template could not be read',
    },
    useTemplateGeneration: {
      failedToCreateTemplate: 'Failed to create the template. Please try again.',
      failedToStartTemplateGeneration: 'Failed to start template generation',
      failedToUploadFilesPlease: 'Failed to upload files. Please try again.',
      templateGenerationStreamFailed: 'Template generation stream failed',
    },
  },
  editBrief: {
    editBriefModal: {
      briefName: 'Brief name',
      briefRenamed: 'Brief renamed',
      cancel: 'Cancel',
      enterTheBriefName: 'Enter the brief name…',
      failedToRenameBrief: 'Failed to rename brief',
      renameBrief: 'Rename brief',
      save: 'Save',
    },
  },
} as const;
